import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useParams } from 'react-router-dom';
import queryRequestInfo from 'api/ShareObject/queryRequestInfo';
import { DisplayData } from 'components/details/EditorDetails';

export default function useRequestInfo() {
    const client = useClient();
    const [loading, setLoading] = useState(true);
    const [displayData, setDisplayData] = useState<DisplayData[]>([]);
    const [error, setError] = useState<boolean>(false);
    const params = useParams();

    useEffect(() => {
        if (client) {
            setLoading(true);
            if (params.uri) {
                client.query(queryRequestInfo(params.uri)).then((response) => {
                    if (!response.errors) {
                        setDisplayData([
                            {
                                label: 'Requesters',
                                value: response.data.getShareObject.owner,
                            },
                            {
                                label: 'Request Group',
                                value: response.data.getShareObject
                                    .samlGroupName,
                            },
                            {
                                label: 'Request Environment',
                                value: response.data.getShareObject
                                    .environmentName,
                            },
                            {
                                label: 'Request Organization',
                                value: response.data.getShareObject.orgaName,
                            },
                            {
                                label: 'AWS Accounts',
                                value: response.data.getShareObject.shareAccounts.toString(),
                            },
                            {
                                label: 'Region',
                                value: response.data.getShareObject.principal
                                    .region,
                            },
                        ]);
                    } else {
                        setError(true);
                    }
                    setLoading(false);
                });
            }
        }
    }, [client, params.uri, setError]);
    return { displayData, loading, error };
}
